"use client";

import StoryViewsModalV2 from "components/ui/v2/explore/StoryViewsModalV2";
import { Modal } from "components/ui/v2/modal";
import { Eye } from "lucide-react";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";

export interface StoryViewCounterV2Props {
  count: number | undefined;
  storyId: string;
}

export function StoryViewCounterV2({ count, storyId }: StoryViewCounterV2Props) {
  const { t } = useTranslation("explore");
  const { t: tCommon } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [viewsCount, setViewsCount] = useState(0);

  useEffect(() => {
    if (!open) {
      setViewsCount(0);
    }
  }, [open]);

  const displayCount = count ?? 0;
  const label =
    displayCount === 1
      ? t("{{count}} vista", { count: displayCount })
      : t("{{count}} vistas", { count: displayCount });

  const title =
    viewsCount > 0
      ? `${t("Quién vio esta story")} (${viewsCount})`
      : t("Quién vio esta story");

  return (
    <>
      <button
        type="button"
        className="inline-flex items-center gap-1.5 rounded-full bg-white/90 px-2.5 py-1 text-xs font-semibold text-slate-800 transition hover:bg-white"
        onClick={() => setOpen(true)}
        aria-label={label}
      >
        <Eye className="h-3.5 w-3.5" />
        {label}
      </button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size="md"
        backdrop="static"
        eyebrow={tCommon("Explorar")}
        title={title}
        panelClassName="max-h-[min(88vh,680px)]"
        headerClassName="px-4 py-2.5 sm:px-5 sm:py-3"
        bodyClassName="px-4 py-3 sm:px-5 sm:py-3.5"
      >
        <StoryViewsModalV2
          storyId={storyId}
          onViewsCountChange={setViewsCount}
        />
      </Modal>
    </>
  );
}

export default StoryViewCounterV2;
